import { CompartmentCard } from "@/src/components/cards";
import { ListConstructor } from "@/src/components/fetchableLists";
import { CardType, FolderItem, Patient, SimpleExam } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getItemId, uid } from "@/src/utils/utils";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";

import { openExamsChoiceList } from "../exams/examsChoiceList";
import { RetrievePendingExamResultsButton } from "../exams/pendingExamsButton";
import { openLabChoiceDrawer } from "../explorations/biologyIframesButton";
import { ExamCard } from "./examCard";
import { ExamGroupCard } from "./examGroupCard";

function ExamsCompartment({
  title,
  patient,
  parent,
  type,
  shouldShowSecondaryButton = true,
}: {
  title?: string;
  patient: Patient;
  parent: FolderItem;
  type?: CardType;
  shouldShowSecondaryButton?: boolean;
}) {
  const [reload, setReload] = useState(0);
  let [searchKey, setSearchKey] = useState("");
  let { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ["ExamsCompartment", searchKey, patient.id, reload],
    queryFn: () =>
      apiFetch(
        "exams",
        "loadMany",
        {
          patientId: getItemId(patient),
          parentId: getItemId(parent),
        },
        "Erreur lors du chargement des examens"
      ),
  });

  function getGroupedExams(exams: SimpleExam[]) {
    let groupedExams: Record<string, SimpleExam[]> = {};
    for (let exam of exams) {
      let examGroupId = getItemId(exam.examGroup);
      groupedExams[examGroupId] ||= [];
      groupedExams[examGroupId].push(exam);
    }
    return groupedExams;
  }

  const groupedExams = getGroupedExams(data?.exams || []);

  return (
    <CompartmentCard
      color={type || "orange"}
      title={title || "Examens réalisés"}
      onClick={async () => {
        await openExamsChoiceList({
          categoryId: null,
          patient,
          parent,
          onConfirm: (exams) => {
            setReload(reload + 1);
          },
        });
      }}
      onSecondaryClick={
        shouldShowSecondaryButton === false
          ? undefined
          : () => openLabChoiceDrawer()
      }
      secondaryButtonTitle={
        shouldShowSecondaryButton === false ? undefined : "Laboratoires"
      }
    >
      <RetrievePendingExamResultsButton
        patientId={getItemId(patient)}
        parentId={getItemId(parent)}
        onFound={async () => {
          setReload(reload + 1);
        }}
      />
      <ListConstructor
        data={data?.exams}
        isLoading={isLoading}
        isError={isError}
        error={error}
      >
        <div className="grid c1 gap10">
          {Object.entries(groupedExams).map(([examGroupId, exams]) => {
            const examGroup = exams[0].examGroup;

            console.log({ examGroupId, examGroup });

            if (examGroup) {
              return (
                <ExamGroupCard
                  key={uid()}
                  group={examGroup}
                  exams={exams}
                  patient={patient}
                  allExams={data?.exams || []}
                  allAppointments={data?.appointments || []}
                  allServices={data?.services || []}
                  onChange={() => {
                    setReload(reload + 1);
                  }}
                />
              );
            }

            return (
              <div key={uid()} className="c1 gap10">
                {exams.map((exam, index) => (
                  <ExamCard
                    key={uid()}
                    exam={exam}
                    patient={patient}
                    allExams={data?.exams || []}
                    allAppointments={data?.appointments || []}
                    allServices={data?.services || []}
                    onChange={() => {
                      setReload(reload + 1);
                    }}
                  />
                ))}
              </div>
            );
          })}
        </div>
      </ListConstructor>
    </CompartmentCard>
  );
}

export { ExamsCompartment };
